export default "/4.png"